import { Button } from "primereact/button";
import { useCallback, useState } from "react";
import { useAppContext } from "../../providers/ProviderAppContainer";
import HasRequiredAuthority from "../dependencies/HasRequiredAuthority";
import ConfirmationWrapper from "../common/ConfirmationWrapper";
import { AUTHORITIES } from "../../constants";

export default function CourseCarouselImage({ id, click_link, source, onDeleted, onEdit }) {
    const { requestAPI, showToast } = useAppContext();
    const [deleting, setDeleting] = useState();

    const deleteCarouselImage = useCallback(() => {
        requestAPI({
            requestPath: `courses/carousel/${id}`,
            requestMethod: "DELETE",
            setLoading: setDeleting,
            parseResponseBody: false,
            onResponseReceieved: (_, responseCode) => {
                if (responseCode === 204) {
                    showToast({ severity: "success", summary: "Deleted", detail: "Carousel Image Deleted", life: 1000 });
                    onDeleted?.(id);
                } else {
                    showToast({ severity: "error", summary: "Failed", detail: "Failed To Delete Carousel Image !", life: 2000 });
                }
            },
        });
    }, [id, onDeleted, requestAPI, showToast]);

    return (
        <div className="relative">
            <img
                onClick={() => {
                    if (click_link) window.open(click_link, "_blank");
                }}
                className="w-full h-8rem block"
                src={source}
                alt={source}
            />

            <HasRequiredAuthority requiredAuthority={AUTHORITIES.UPDATE_COURSE}>
                <div className="absolute bottom-0 right-0 m-2 flex gap-1">
                    <Button
                        icon="pi pi-pencil"
                        rounded
                        outlined
                        severity="info"
                        aria-label="Edit"
                        size="small"
                        onClick={(e) => {
                            e.stopPropagation();
                            onEdit?.({ id, source, click_link });
                        }}
                    />
                    <ConfirmationWrapper action={deleteCarouselImage}>
                        <Button
                            icon="pi pi-trash"
                            rounded
                            outlined
                            severity="danger"
                            aria-label="Delete"
                            loading={deleting}
                            size="small"
                        />
                    </ConfirmationWrapper>
                </div>
            </HasRequiredAuthority>
        </div>
    );
}
